import { convertImageFromDto } from "@/modules/dtos/imageDto"
import { ExerciseScoreEntity } from "@/modules/scores/scoreboard/entities/exerciseScoreEntity"
import type { ScoreboardRankingDto } from "@/modules/scores/scoreboard/gateway/scoreboardDto"
import { ScoreType } from "@modules/scores/scoreTypes"
import { type HUImage } from "@modules/types/imageTypes"

export class ScoreboardRankingEntity {
  userId: string
  position: number
  firstname: string
  lastname: string
  score: ExerciseScoreEntity | null
  scoreType: ScoreType
  avatar: HUImage | null

  constructor(scoreboardRanking: ScoreboardRankingEntity) {
    this.userId = scoreboardRanking.userId
    this.position = scoreboardRanking.position
    this.firstname = scoreboardRanking.firstname
    this.lastname = scoreboardRanking.lastname
    this.score = scoreboardRanking.score
    this.scoreType = scoreboardRanking.scoreType
    this.avatar = scoreboardRanking.avatar
  }

  static fromDto(dto: ScoreboardRankingDto): ScoreboardRankingEntity {
    return new ScoreboardRankingEntity({
      userId: dto.userId,
      position: dto.position,
      firstname: dto.firstname,
      lastname: dto.lastname,
      score: dto.score ? ExerciseScoreEntity.fromDto(dto.score) : null,
      scoreType: dto.scoreType,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : null,
    })
  }
}
